'use strict';


export class InvitationStructureCtrl
{
	$scope;
	$filter;
	$mdDialog;
	jsDataService;
	structure = {};


	constructor($scope, $filter, $mdDialog, jsDataService){
		'ngInject';
		this.$scope = $scope;
		this.$mdDialog = $mdDialog;
		this.$filter = $filter;
		this.jsDataService = jsDataService;
		this.structure = jsDataService.get('structure', {});

		switch (this.structure.structure_key) {
			case 'a3_participants':
			case 'a4_1_work_activities': {
				if (Array.isArray(this.structure.fields)) {
					this.structure.fieldsArray = [...this.structure.fields];
					const fieldsByName = {};
					for (let field of this.structure.fields) {
						fieldsByName[field.name] = field;
					}
					this.structure.fieldsByName = fieldsByName;
				} else {
					this.structure.fieldsByName = this.structure.fields;
					this.structure.fieldsArray = Object.values(this.structure.fields);
				}
				this.structure.fields = this.structure.fieldsByName;

				break;
			}
			default:
				break;
		}

		if (!this.$scope.ctrlBaseForm) {
			this.$scope.ctrlBaseForm = {};
		}

		this.$scope.$watch(
			() => this.structure.instructions,
			(newInstructions, oldInstructions) => {
				if (newInstructions !== oldInstructions) {
					if (this.$scope.ctrlBaseForm) {
						this.$scope.ctrlBaseForm.$setDirty();
					}
					this.$scope.$emit('autosaveFormChanged');
				}
			},
			true
		);
		if(this.structure.has_fields){
			this.$scope.$watch(
				() => this.structure.fields,
				(newFields, oldFields) => {
					if (newFields !== oldFields) {
						if (this.$scope.ctrlBaseForm) {
							this.$scope.ctrlBaseForm.$setDirty();
						}
						this.$scope.$emit('autosaveFormChanged');
					}
				},
				true
			);
		}
	}

	cancel = function(){
		const url = this.jsDataService.get('previewUrl');
		if(url){
			this.$scope.goUrl(url);
		}
	};

	save = function(){
		this.saveData();
	};

	showLimit = function(field){
		return (typeof(field)!=='undefined' && (field.type==='inputString' || field.type==='text'));
	};

	showTextarea = function(field){
		return (typeof(field)!=='undefined' && (field.type==='text' || field.type==='check'));
	};

	saveData = function(){
		if(this.jsDataService.get('saveUrl')){
			this.$scope.basicHttpConfigProcess({
				url: this.jsDataService.get('saveUrl'),
				method: 'POST',
				data: this.structure
			}).then((response) => {

			});
	   }
	   return null;
   };

	getTitleFormated(){
		let nr = '';
		if(this.structure.numbered == 1 && this.structure.number !== ''){
			nr = this.structure.number + ' ';
		}
		return nr + this.structure.title;

	}

    addA2_declarationsField = function() {
		if(typeof(this.structure.fields)==='undefined'){
			this.structure.fields = [];
		}
		this.structure.fields.push({ name: 'a2_declarations_declaration', type: 'check', title: '', section: 'a2_declarations', value: '' , ord: this.structure.fields.length, active: false, mandatory: false, alert: '', explain: '', explain_on: true, alert_on: true});
		this.structure.has_fields = true;
    };

    removeA2_declarationsField = function(ev, field, index) {
			const confirmTexts = this.jsDataService.get('removeConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.structure.fields.splice(index, 1);
			}, () => {});
		if(typeof(field.id) !== 'undefined' && field.section!=='a2_declarations'){
			return;
		}

    };

	getTemplate = function () {
		switch(this.structure.structure_key){
			case 'a3_participants':
			case 'a4_1_work_activities':

//				this.structure.fields =
				return 'invitations/' + this.structure.structure_key + '.html';
			default:

				return 'invitations/appform_basic_fields.html';
		}

	};

	isField(name){
		return (typeof(this.structure.fields[name]) !== 'undefined');
	}

	autosavePostFields() {
		this.saveData();
	}

}

